import { useSyncExternalStore } from "react";

/** One row from /socialprofile/profile/ impersonation_targets. */
export interface ImpersonationTarget {
	cms_user_id: string;
	first_name: string;
	last_name: string;
	role: string | null;
	location: string | null;
	avatar_url: string | null;
}

/**
 * Session-scoped impersonation state (mirrors iOS AppState.impersonatingAs —
 * in-memory only, cleared on reload/sign-out). A plain module store so the
 * axios interceptor can read it synchronously outside React.
 */
let current: ImpersonationTarget | null = null;
const listeners = new Set<() => void>();

export function getImpersonation(): ImpersonationTarget | null {
	return current;
}

export function setImpersonation(target: ImpersonationTarget | null) {
	current = target;
	for (const l of listeners) l();
}

function subscribe(listener: () => void) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function useImpersonation(): ImpersonationTarget | null {
	return useSyncExternalStore(subscribe, () => current);
}

export function targetName(t: ImpersonationTarget): string {
	return `${t.first_name} ${t.last_name}`.trim();
}
